jQuery(function ($) {
 
 //menu container animation
  let menu_tl = gsap.timeline({
    paused: true,
  })
  .fromTo('.menu', {
    yPercent: ()=>-100,
  }, {
    yPercent: ()=>0,
    duration: 1,
    ease: 'power1.out',
  })
  .fromTo('.menu .logo', {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
    yPercent: 100,
  }, {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    yPercent: 0,
    duration: .6,
    stagger: .12,
    ease: 'power2.out',
  }, '>-.2')
  .fromTo('.menu .menu_list > .menu-item > a', {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
    yPercent: 100,
  }, {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    yPercent: 0,
    duration: .6,
    stagger: .12,
    ease: 'power2.out',
  }, '>-.4')
  .fromTo('.menu_data', {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
    yPercent: 100,
  }, {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    yPercent: 0,
    duration: .5,
    stagger: .1,
    ease: 'power2.out',
  }, '>-.4')

  let menu_open = false
  $('#menu_button').on('click', function() {
    menu_open = !menu_open
    if (menu_open) {
      menu_tl.play()
      $(this).addClass('open')
    } else {
      menu_tl.reverse()
      $(this).removeClass('open')
      submenus_triggers.each((i) => {
        tween[i].reverse();
      })
    }
  })

  //sub menus animations
  var submenus = gsap.utils.toArray('.sub-menu'),
  tween = [];

  submenus.forEach((submenu) => {
    let getSubmenuHeight = ()=>$(submenu).children('.sub-menu-content')[0].offsetHeight

    tween.push({
      rev: true,
      reversed() {
        return this.rev
      },
      play() {
        this.rev = false
        $(submenu).css({
          height: getSubmenuHeight()
        })
      },
      reverse() {
        this.rev = true
        $(submenu).css({
          height: 0
        })
      },
    })  
  });
  
  let submenus_triggers = $('.menu-item-has-children').children('a')
  
  submenus_triggers.each(function(i) {
    $(this).on('click', function(e) {
      e.preventDefault();

      submenus_triggers.each((j) => {
        if (i != j)
          !tween[j].reversed() && tween[j].reverse();
      })

      tween[i].reversed() ? tween[i].play() : tween[i].reverse();
    });
  });

  new MenuSeparators('.sub-menu .menu-item', 1.1, '●')
  new MenuSeparators('.menu_data .text', .8, '|')  
})